export default function (http) {
    return {
        queryByPage (data){
            return http.json({
                url: '/sys/message/query',
                data
            });
        },

        queryMyMessage (data){
            return http.json({
                url: '/sys/message/queryMyMessage',
                data
            });
        },
        saveInfo(data) {
            return http.json({
                url: `/sys/message/save`,
                data
            })
        },
        getInfo(data) {
            return http.json({
                url: `/sys/message/get?id=${data.id}`,
                data
            })
        },
        delete (data){
            return http.json({
                url: '/sys/message/delete',
                data
            });
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/message.js